import { useAdmin } from '@vtex/raccoon-next'
import { Analytics } from 'analytics'
import type { DefaultProps } from 'typings'
import { AnalyticsProvider as AnalyticsBaseProvider } from 'use-analytics'
import { useAmplitudePlugin, useRedshiftPlugin } from '../hooks'

export function AnalyticsProvider(props: DefaultProps) {
  const { production } = useAdmin()
  const analytics = Analytics({
    app: 'vtex.admin-promotions',
    plugins: [useAmplitudePlugin(), useRedshiftPlugin()],
    debug: !production,
  })

  return (
    <AnalyticsBaseProvider instance={analytics}>
      {props.children}
    </AnalyticsBaseProvider>
  )
}
